export const Generals = {
  ftts: 'ftts',
  mpbn: 'mpbn',
  otn: 'otn',
  ipran: 'ipran',
  map: 'graph',
  tabular: 'table',
  userManagement: 'userManagement',
  businessIntelligence: 'businessIntelligence',
  selectedTab: 'selectedTab',
  totalMpbnAlarms: 'totalMpbnAlarms',
  totalFttsAlarms: 'totalFttsAlarms',
  totalOtnAlarms: 'totalOtnAlarms',
  totalIpranAlarms: 'totalIpranAlarms',
  live: 'live',
  history: 'history',
  user: 'user',
  group: 'group',
  permission: 'permission',
  userManagementPermission: 'User Management',
  partnerNetwork: 'Partner Network',
  inventory: 'Inventory Management',
};

// Navigation icon indices for better maintainability
export const NavigationIcons = {
  HOME: 0,
  USER_MANAGEMENT: 1,
  PARTNER_NETWORK: 2,
  BUSINESS_INTELLIGENCE: 3,
  NETWORK_MONITORING: 4,
  INVENTORY: 5,
  INVOICE_MANAGEMENT: 7,
};
